module.exports = __webpack_public_path__ + "img/shrec22.b122fa73.png";